// frontend/src/utils/taakTypeKeuze.ts
import { TijdlijnTaakType } from "../enums";

/**
 * D31 (overleg Martine 02-09-2026): "versturen factuur" is geen taak meer —
 * facturen lopen via de facturenmodule. De twee factuur-taaktypes verdwijnen
 * uit de nieuwe-taak-kiezer en uit de duurtabel in Beheer; bestaande taken
 * blijven staan en houden hun label (geen migratie).
 */
export const VERBORGEN_TAAKTYPES: readonly TijdlijnTaakType[] = [
  TijdlijnTaakType.VERSTUREN_FACTUUR,
  TijdlijnTaakType.VERSTUREN_AANVULLENDE_FACTUUR,
];

// Standaard-checklist voor "Voorbereiden PM" (nieuwe taak en taak wijzigen);
// alleen geprefilled zolang de gebruiker het veld niet zelf heeft ingevuld.
export const VOORBEREIDEN_PM_COMMENT_TEMPLATE = [
  "- Dossier invullen",
  "- Opdrachtgever bevestigen",
  "- Radiologie aanmelden",
  "- Formulier",
  "- Opvragen",
].join("\n");

/** True voor een (ruw, uit de API) taaktype dat niet meer kiesbaar is. */
export function isVerborgenTaakType(
  taakType: string | null | undefined,
): boolean {
  return (VERBORGEN_TAAKTYPES as readonly string[]).includes(taakType ?? "");
}

/**
 * De kiesbare taaktypes in enum-volgorde. `huidig` (het type van een taak die
 * bewerkt wordt) blijft altijd kiesbaar, anders raakt die taak haar label kwijt.
 */
export function kiesbareTaakTypes(
  huidig?: TijdlijnTaakType,
): TijdlijnTaakType[] {
  return Object.values(TijdlijnTaakType).filter(
    (type) => type === huidig || !VERBORGEN_TAAKTYPES.includes(type),
  );
}
